var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commentator clearfix"},[_c('div',{staticClass:"leftBox"},[_c('InputSpurce'),_c('OutputSpurce')],1),_c('div',{staticClass:"rightBox"},[_c('EventList',{attrs:{"selectInput":_vm.selectInput,"selectOutput":_vm.selectOutput}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }